import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Learn20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5351 2.42358C10.1964 2.26314 9.80357 2.26314 9.46487 2.42358L1.13286 6.37032C0.179674 6.82183 0.179669 8.17816 1.13286 8.62967L3.25003 9.63254L3.25 14.0909C3.25 14.8616 4.32043 15.7251 4.85277 16.1381C5.91408 16.9614 7.57401 17.75 9.99998 17.75C12.4259 17.75 14.0859 16.9614 15.1472 16.1381C15.6795 15.7251 16.75 14.8616 16.75 14.0909V9.6325L17.75 9.15882V11.7857C17.75 12.1999 18.0858 12.5357 18.5 12.5357C18.9142 12.5357 19.25 12.1999 19.25 11.7857V8.35239C19.7961 7.76907 19.6685 6.74992 18.8671 6.37032L10.5351 2.42358ZM2.25196 7.5L9.99998 3.82988L17.748 7.5L9.99998 11.1701L2.25196 7.5ZM15.25 10.343L10.5351 12.5764C10.1964 12.7368 9.80357 12.7368 9.46487 12.5764L4.75003 10.3431L4.75 13.8814C5.87905 15.5766 8.05552 16.25 9.99998 16.25C11.9445 16.25 14.1209 15.5766 15.25 13.8814V10.343Z'
      fill='currentColor'
    />
  </Svg>
);

Learn20.displayName = 'Learn20';
export default Learn20;
